import routerOptions0 from "/app/solution/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  linkActiveClass: "nuxt-link--active",
  linkExactActiveClass: "nuxt-link--exact-active",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}